export enum ActionTypes {
  UserType = 'userType',
  UserTypeRequest = 'userType.request',
  UserTypeSuccess = 'userType.success',
  UserTypeFailure = 'userType.failure',
}
